import { render, staticRenderFns } from "./CtaButtonConstructor.vue?vue&type=template&id=d815cd2a"
import script from "./CtaButtonConstructor.vue?vue&type=script&lang=js"
export * from "./CtaButtonConstructor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/devstark/spreadsimple/spreadsimple-app/main-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d815cd2a')) {
      api.createRecord('d815cd2a', component.options)
    } else {
      api.reload('d815cd2a', component.options)
    }
    module.hot.accept("./CtaButtonConstructor.vue?vue&type=template&id=d815cd2a", function () {
      api.rerender('d815cd2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/cta-button-constructor/CtaButtonConstructor.vue"
export default component.exports